module.exports = __webpack_public_path__ + "static/media/email.a423a1ec.svg";